import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import SVG from 'components/widgets/icons/svg';

import { getFolderOpenUrl } from 'utils/google-drive-utils';


export default function DriveFilesList({ folder, className }) {
  return (
    <a href={getFolderOpenUrl(folder.fileId)} target="_blank" className={classNames('unadorned', 'drive-folder-link', className)}>
      <SVG src="svg/new-tab.svg" className="new-tab" />
      <span>Open in Drive</span>
    </a>
  );
}

DriveFilesList.propTypes = {
  folder: PropTypes.object.isRequired,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/models/files/drive-folder-link.js